export class CINote {
    id: number;
    sfClearanceItemId: string;
    description: string;
    user: string;
    role: string;
    createdById: string;
    createdDate: Date;
    lastModifiedById: string;
    lastModifiedDate: Date;
    isReadByProduction: boolean;
    isReadByClearance: boolean;
}
